import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import GroupsPanel from "components/compare-groups-panel"
import CompareDownload from "components/compare-download"
import { DOWNLOAD_FILENAME, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import Panel from "./panel"
import "./styles.scss"

function CompareTopicSummaryTables({
  data,
  items,
  columns,
  setGroup,
  saveGroupToStore,
  storeName,
  selectedGroup,
  groups,
  fixedItemNumber,
  smartTradeRiskData,
  isPortfolio,
  maxNbColumns,
  fileName,
  tableDownloadData,
}) {
  return <Paper className="components_compare-topic-summary-tables" square elevation={0}>
    <div id="topic-summary-risk-header">
      <h2>Risk</h2>
      <CompareDownload
        fileName={fileName}
        isTopicSummary
        items={columns}
        tableData={data}
        selectedGroup={selectedGroup}
        tableDownloadData={tableDownloadData}
      />
    </div>
    <Panel items={items.totalRisk} columns={columns} data={data} fixedItemNumber={fixedItemNumber} />
    <Panel
      items={items.risk}
      columns={columns}
      data={data}
      panelTitle="Risk Decomposition"
      titleTooltipContent="Risk decomposition as % variance, where specific % + factor % = 100%"
      fixedItemNumber={fixedItemNumber}
    />
    {smartTradeRiskData && !isPortfolio && <Panel items={smartTradeRiskData.items} columns={columns} data={smartTradeRiskData.data} fixedItemNumber={fixedItemNumber} />}

    <h2>Composition Summary</h2>
    <Panel items={items.compositionSummary} {...{ columns, data, fixedItemNumber }} />
    <Panel items={items.beta} {...{ columns, data, fixedItemNumber }} />
    <GroupsPanel
      items={items.groups}
      {...{
        columns,
        data,
        groups,
        selectedGroup,
        saveGroupToStore,
        storeName,
        setGroup,
        fixedItemNumber,
        maxNbColumns,
      }}
    />
  </Paper>
}

CompareTopicSummaryTables.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  items: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  setGroup: PropTypes.func.isRequired,
  saveGroupToStore: PropTypes.func.isRequired,
  storeName: PropTypes.string,
  selectedGroup: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  fixedItemNumber: PropTypes.bool,
  smartTradeRiskData: PropTypes.object,
  isPortfolio: PropTypes.bool,
  maxNbColumns: PropTypes.number,
  fileName: DOWNLOAD_FILENAME,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
}

export default CompareTopicSummaryTables
